module.exports = __webpack_public_path__ + "static/media/GDocsDraftPrivacyNotice_ES.bdfd28e4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GDocsDraftPrivacyNotice_ES.pdf
// module id = 689
// module chunks = 4